import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/auth-context';

export function useAdminClaim() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['auth-claims', user?.uid],
    queryFn: async () => {
      // Tving refresh slik at ferske custom claims (admin) er med på første forsøk.
      const token = await user?.getIdTokenResult(true);
      return token?.claims.admin === true;
    },
    enabled: Boolean(user),
  });
}
